export const postInBookmarks = (bookmarks, postId) =>
 bookmarks.find((bookmark) => bookmark === postId)
;